<template>
  <el-dialog
    title="添加职员"
    width="1230px"
    :visible="visible"
    @close="close"
    :close-on-click-modal="false"
  >
    <div class="mb10 flex flex-between">
      <el-radio-group
        v-model="searchCondition.statusType"
        size="small"
        @change="statusTypeChange"
      >
        <!-- <el-radio-button label="organization">按组织架构</el-radio-button> -->
        <el-radio-button v-if="!isRole" label="role">按角色</el-radio-button>
      </el-radio-group>
      <!-- <div>
           <el-button type="primary" size="small" @click="innerVisible=true"
              >新增职员</el-button
            >
        </div> -->
    </div>
    <div class="bd1 flex" style="width:1200px">
      <div class="left">
        <el-scrollbar style="height: 100%" class="page-component__scroll">
          <div class="all node pointer" @click="searchAll">全部</div>
          <side-emp-item
            :active="active"
            @check="check"
            :list="tableData"
          ></side-emp-item>
        </el-scrollbar>
      </div>
      <div class="flex-1 p10" style="width: 907px;">
        <div class="mb10 flex flex-between mt10">
          <div style="opacity: 0;"></div>
          <!-- <el-button type="primary" size="small" @click="addemp"
            >新增职员</el-button
          > -->
          <div>
            <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.queryKey"
              placeholder="请输入导购姓名/工号 "
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div v-if="selectType === 'multiple'">
          <el-table
            max-height="440"
            @selection-change="getChecked"
            :data="list"
            style="width: 100%"
            stripe
            size="small"
            border
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="部门"
              show-overflow-tooltip
              prop="departName"
              column-key="departName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="账号"
              show-overflow-tooltip
              prop="username"
              column-key="username"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="姓名"
              prop="realname"
              column-key="realname"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="工号"
              prop="workNum"
              column-key="workNum"
            ></el-table-column>
          </el-table>
        </div>
        <div v-else>
          <div
            class="mb10 flex flex-start item-center"
            v-if="recordList.length"
          >
            最近选择：
            <el-tag
              size="small"
              class="pointer"
              type="info"
              closable
              v-for="(v, i) in recordList"
              :key="i"
              @click="seleckEmp(v)"
              @close="del(v)"
              >{{ v.realname }}</el-tag
            >
          </div>
          <div class="tips">提示：点击表格行即可选择</div>
          <el-table
            max-height="440"
            highlight-current-row
            @current-change="handleCurrentChange"
            :data="list"
            style="width: 100%"
            stripe
            size="small"
            border
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="部门"
              show-overflow-tooltip
              prop="departName"
              column-key="departName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="账号"
              show-overflow-tooltip
              prop="username"
              column-key="username"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="姓名"
              prop="realname"
              column-key="realname"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="工号"
              prop="workNum"
              column-key="workNum"
            ></el-table-column>
          </el-table>
        </div>

        <div
          class="hm-pagination"
          v-if="searchCondition.statusType === 'organization'"
        >
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      width="1000px"
      title="新增职员"
      :visible.sync="innerVisible"
      append-to-body> -->
    <el-drawer
      :wrapperClosable="false"
      custom-class="hm-drawer"
      title="新增职员"
      :visible="innerVisible"
      direction="rtl"
      :modal="false"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <el-form
          :model="detailsRuleForm"
          :rules="detailsRules"
          ref="detailsRuleForm"
          label-width="100px"
          class="large-label-form"
        >
          <el-form-item label="用户账号" prop="username">
            <el-input
              clearable
              v-model.trim="detailsRuleForm.username"
              maxlength="20"
              size="small"
              style="width: 200px"
              placeholder="请输入用户账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户密码" prop="password">
            <el-input
              clearable
              autocomplete="new-password"
              style="width: 200px"
              v-model.trim="detailsRuleForm.password"
              maxlength="20"
              type="password"
              size="small"
              placeholder="请输入用户密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input
              clearable
              type="password"
              autocomplete="new-password"
              style="width: 200px"
              v-model.trim="detailsRuleForm.confirmpassword"
              maxlength="20"
              size="small"
              placeholder="请确认输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名字" prop="realname">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="detailsRuleForm.realname"
              maxlength="20"
              size="small"
              placeholder="请输入用户名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属机构" prop="orgCodes">
            <el-cascader
              ref="cascader"
              clearable
              style="width: 200px"
              v-model="detailsRuleForm.orgCodes"
              :props="props"
              :show-all-levels="false"
              size="small"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="角色分配" prop="ruleLists">
            <el-select
              v-model="detailsRuleForm.ruleLists"
              value-key="id"
              multiple
              filterable
              style="width: 200px"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in roleList"
                :key="i"
                :label="item.roleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号" prop="workNum">
            <el-input
              maxlength="8"
              style="width: 200px"
              clearable
              @input="filterGt0OrFixed2('workNum')"
              v-model.trim="detailsRuleForm.workNum"
              size="small"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              style="width: 200px"
              clearable
              v-model.trim="detailsRuleForm.phone"
              size="small"
              type="number"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="在职状态" prop="workingState">
            <el-select
              style="width: 200px"
              v-model="detailsRuleForm.workingState"
              placeholder="请选择在职状态"
              size="small"
            >
              <el-option label="在职" value="yes"> </el-option>
              <el-option label="离职" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否主管" prop="isManager">
            <el-select
              style="width: 200px"
              size="small"
              v-model="detailsRuleForm.isManager"
              placeholder="请选择是否主管"
            >
              <el-option label="是" value="yes"> </el-option>
              <el-option label="否" value="no"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="regDay">
            <el-date-picker
              style="width: 200px"
              size="small"
              v-model="detailsRuleForm.regDay"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select
              style="width: 200px"
              size="small"
              v-model="detailsRuleForm.sex"
              placeholder="请选择性别"
            >
              <el-option label="男" value="1"> </el-option>
              <el-option label="女" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="detailsRuleForm.birthday"
              type="date"
              placeholder="请选择时间"
              style="width: 200px"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <div class="drawer-footer flex flex-center item-center">
        <el-button
          @click="submitForm('detailsRuleForm')"
          type="primary"
          size="small"
          >提 交</el-button
        >
        <el-button
          @click="resetForm('detailsRuleForm')"
          type="info"
          size="small"
          >取 消</el-button
        >
      </div>
    </el-drawer>
    <!-- </el-dialog> -->
    <div slot="footer" class="dialog-footer flex flex-center">
      <el-button @click="add" v-if="!isRole" type="primary" size="small">确认选择</el-button>

      <el-button @click="confirm" v-if="isRole" type="primary" size="small">确 认</el-button>

      <el-button @click="setUpAnAppointment" v-if="!isRole" type="primary" size="small">确认并设置预约范围</el-button>

      <el-button @click="close" type="info" size="small">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SideEmpItem from "@/components/SideEmpItem";
import Bus from "@/utils/bus.js";
import { request } from "@/utils/request";
// import { queryActivityCategory } from "@/utils/utils";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: ""
    },
    isRole: {
      type: Boolean,
    }
  },
  components: { SideEmpItem },
  data() {
    const validatorOrgCodesFunc = function(rule, val, callback) {
      if (this.isArray(val)) {
        if (val.length <= 0) {
          return callback(new Error("请选择所属机构"));
        }
      } else {
        if (val === "") {
          return callback(new Error("请选择所属机构"));
        }
      }

      // if (this.ruleForm.password === this.ruleForm.confirmpassword) {
      //   callback();
      // } else {
      //
      // }
      callback();
    }.bind(this);
    const validatorFunc = function(rule, val, callback) {
      if (
        this.detailsRuleForm.password === this.detailsRuleForm.confirmpassword
      ) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);
    const checkPhone = function(rule, val, callback) {
      if (/^1[0-9]{10}$/.test(val)) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "phone",
            fieldVal: val,
            dataId: this.userId
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("手机号已存在"));
          });
      }
    }.bind(this);
    const checkUsername = (rule, val, callback) => {
      if (val) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "username",
            fieldVal: val
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("用户名已存在"));
          });
      }
    };
    return {
      recordList: [],
      roleAllList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      innerVisible: false,
      active: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      organizationList: [],
      activeIndex: "2",
      roleList: [],
      tableData: [],
      searchCondition: {
        statusType: "organization"
      },
      data: {},
      orgCode: "",
      target: {},
      currentRow: {},
      checkedRowList: [],
      roleId: "",
      detailsRuleForm: {
        username: "",
        realname: "",
        password: "",
        confirmpassword: "",
        phone: "",
        context: "",
        workNum: "",
        birthday: "",
        sex: "",
        regDay: "",
        workingState: "",
        isManager: "",
        ruleLists: [],
        orgCodes: [],
        address: ""
        // username: "",
        // password: "",
        // confirmpassword: "",
        // realname: "",
        // birthday: "",
        // sex: "",
        // email: "",
        // phone: "",
        // avatar:
        //   "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png"
      },
      detailsRules: {
        username: [
          {
            required: true,
            message: "请输入用户账号！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          },
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        orgCodes: {
          required: true,
          validator: validatorOrgCodesFunc,
          message: "请选择所属机构"
        },
        ruleLists: {
          required: true,
          message: "请选择角色"
        },
        workNum: {
          required: true,
          trrger: "blur",
          message: "请输入工号"
        },
        workingState: {
          required: true,
          message: "请选择在职状态"
        },
        isManager: {
          required: true,
          message: "请选择是否主管"
        },
        // phone: [
        //   {
        //     required: true,
        //     trrger: "blur",
        //     message: "请输入手机号"
        //   },
        //   {
        //     required: true,
        //     pattern: /^1[0-9]{10}$/,
        //     message: "请输入正确的手机号",
        //     trigger: "blur"
        //   }
        // ],
        realname: [
          {
            required: true,
            message: "请输入用户名称！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          },
          {
            validator: checkPhone,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    Bus.$on("check", target => {
      this.active = target.id;
      this.currentRow = {};
      if (this.searchCondition.statusType === "organization") {
        if (target.orgCode != this.orgCode) {
          this.check(target);
        }
      } else {
        if (target.roleId != this.roleId) {
          this.check(target);
        }
      }
    });
  },
  mounted() {
    this.queryStoreDepartInfoList();
    this.queryList();
    // this.queryAllRoleList();
    this.queryOkrLeaderChoiceRecordList();
  },
  methods: {
    addemp() {
      this.queryRoleList();
      this.innerVisible = true;
      // setTimeout(() => {
      //   this.$refs.detailsRuleForm.resetFields();
      // }, 1000);
      this.$nextTick(() => {
        this.$refs.detailsRuleForm.resetFields();
      });
    },
    async del(v) {
      const { code } = await this.$store.dispatch(
        "delOkrLeaderChoiceRecord",
        v
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryOkrLeaderChoiceRecordList();
      }
    },
    handleClose() {
      this.innerVisible = false;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // async queryAllRoleList() {
    //   const params = {
    //     pageSize: 99999,
    //     pageNo: 1,
    //     column: "createTime",
    //     order: "desc",
    //     loginType: "store"
    //   };
    //   const { result, code } = await this.$store.dispatch(
    //     "queryAllRoleList",
    //     params
    //   );
    //   if (code == "0") {
    //     this.roleAllList = result.records;
    //   }
    // },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this[formName]));
          params.orgCode = this.detailsRuleForm.orgCodes[
            this.detailsRuleForm.orgCodes.length - 1
          ];
          let list = [];
          this.detailsRuleForm.ruleLists.map(v => {
            list.push({ id: v });
          });
          params.ruleList = list;

          params.loginType = "store";
          this.$store.dispatch("addEmployee", params).then(res => {
            if (res.code == "0") {
              this.innerVisible = false;
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.searchCondition.statusType = "organization";
              this.queryList();
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.innerVisible = false;
    },
    seleckEmp(row) {
      this.currentRow = row;
      this.saveOkrLeaderChoiceRecord();
      this.$emit("setEmpInfo", row);
    },
    // 确定并设置预约
    setUpAnAppointment(){
      this.$emit("handleClickScopeOfAppointments", true, this.checkedRowList);
    },
    confirm(){
      console.log(this.checkedRowList);
      this.$emit("handleClickScopeOfAppointments", true, this.checkedRowList);
    },
    add() {
      console.log("选择导购")
      if (this.selectType === "multiple") {
        if (!this.checkedRowList.length) {
          this.$message({
            type: "warning",
            message: "请先选择导购"
          });
        } else {
          this.$emit("setMultipleEmpInfo", this.checkedRowList);
        }
      } else {
        if (!this.currentRow || !this.currentRow.employeeId) {
          this.$message({
            type: "warning",
            message: "请先选择导购"
          });
        } else {
          this.saveOkrLeaderChoiceRecord();
          this.$emit("setEmpInfo", this.currentRow);
        }
      }
    },
    async queryOkrLeaderChoiceRecordList() {
      const { code, result } = await this.$store.dispatch(
        "queryOkrLeaderChoiceRecordList"
      );
      if (code === "0") {
        this.recordList = result;
      }
    },
    async saveOkrLeaderChoiceRecord() {
      let params = {
        leaderId: this.currentRow.employeeId,
        leaderName: this.currentRow.realname
      };
      await this.$store.dispatch("saveOkrLeaderChoiceRecord", params);
    },
    statusTypeChange(val) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.list = [];
      this.currentRow = {};
      this.tableData = [];

      if (val === "organization") {
        this.queryStoreDepartInfoList();
        this.queryList();
      } else {
        this.queryAllRoleList();
      }
    },
    async queryRoleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      const { result } = await this.$store.dispatch("queryRoleList", params);

      const { records } = result;
      this.roleList = records;
    },
    async queryAllRoleList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      const { result, code } = await this.$store.dispatch(
        "queryAllRoleList",
        params
      );
      if (code == "0") {
        const { records } = result;
        records.forEach(v => {
          v.isShow = false;
          v.departName = v.roleName;
        });
        this.tableData = records;
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    // 选择传给父组件
    getChecked(selection) {
      this.checkedRowList = selection;
    },
    check(item) {
      if (this.searchCondition.statusType === "organization") {
        this.orgCode = item.orgCode;
      } else {
        this.roleId = item.id;
      }

      this.currentPage = 1;
      this.pageSize = 10;
      this.queryList();
    },
    searchAll() {
      if (this.searchCondition.statusType === "organization") {
        this.orgCode = "";
        this.currentPage = 1;
        this.active = "";
        this.pageSize = 10;
        this.queryList();
      }
    },
    // mapTree(arr) {
    //   arr.forEach(items => {
    //     //遍历树
    //     items.show = false;
    //     if (items.children && items.children.length) {
    //       this.mapTree(items.children);
    //     }
    //   });
    // },
    async queryStoreDepartInfoList() {
      const { result } = await this.$store.dispatch("queryStoreDepartInfoList");

      this.tableData = result;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        loginType: "store",
        workingState: "yes"
      };
      if (this.searchCondition.statusType === "organization") {
        params.orgCode = this.orgCode;
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        Object.assign(params, searchCondition);
        const { code, result } = await this.$store.dispatch(
          "queryEmployee",
          params
        );
        if (code === "0") {
          const { records, total } = result;
          this.total = total;
          this.list = records;
        }
      } else {
        params.roleId = this.roleId;
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        Object.assign(params, searchCondition);
        const { code, result } = await this.$store.dispatch(
          "queryUserStoreDepartInfoList",
          params
        );
        if (code === "0") {
          //   const { records, total } = result;
          this.total = result.length;
          this.list = result;
        }
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryOrganizationTree() {
      let params = {
        pageNo: 1,
        pageSize: 999,
        loginType: "store"
      };
      const { result } = await this.$store.dispatch(
        "queryOrganizationTree",
        params
      );
      result.records.forEach(v => {
        v.leaf = Boolean(!v.isParent);
        v.show = true;
      });

      this.tableData = result.records;
    },
    async queryOrganizationListByParent(node, resolve) {
      const { result } = await this.$store.dispatch(
        "queryOrganizationListByParent",
        {
          parentId: node.treeStruct
        }
      );
      result.forEach(v => {
        v.leaf = Boolean(!v.isParent);
      });
      resolve(result);
      //   console.log(this.organizationList);
    },

    handleOpen(key, keyPath) {
      this.data = this.organizationList[key];
      this.queryOrganizationListByParent(key);
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.bd1 {
  border: 1px solid #dddddd;
  height: 600px;
}
.left {
  width: 240px;
  height: 100%;
  border-right: 1px solid #ddd;
  .node {
    // height: 44px;
    // line-height: 44px;
    padding: 10px 0 10px 10px;
    // padding-left: 30px;
    // padding-right: 10px;
    overflow: hidden;
    font-size: 14px;
    color: #222222;
  }
  .all {
    background: #f7f7f7;
    font-size: 16px;
    color: #222222;
  }
}

.all {
  background: #f7f7f7;
}
.hm-drawer {
  z-index: 9999 !important;
}
</style>
